import createPlugin from "./createPlugin";
import HubspotFormRenderer from "./Renderer";
import HubspotFormForm from "./Form";

const hubspotFormPlugin = (settings) =>
    createPlugin({
        Renderer: HubspotFormRenderer,
        Controls: HubspotFormForm,

        ...settings,
    });

const hubspotForm = hubspotFormPlugin();
export default hubspotForm;

export { hubspotFormPlugin, HubspotFormRenderer };
